import React, { useContext, useState, useEffect } from 'react';
import BrandedIcon from '../../BrandingWhiteLabel/BrandedIcon';
import { SessionContext } from '../../../context/SessionContext';
import { getTranslation } from '../../../components/Global/helpers';

const TermsAndConditionsError = ({ styles, assetDetails, headerContent }) => {
    const context = useContext(SessionContext);
    const { accountName } = context;
    const [brandPhoneContent, setBrandPhoneContent] = useState(null);

    useEffect(() => {
        const getBrandPhones = async () => {
            const brandPhoneContent = await getTranslation('COC/BrandProvider/BrandPhones.json').then((response) =>
                response.json()
            );
            setBrandPhoneContent(brandPhoneContent);
        };
        getBrandPhones();
    }, []);

    return (
        <div>
            <div className={styles.thanksConfirmation}>
                <BrandedIcon
                    accountName={accountName}
                    iconType={'denied'}
                />
            </div>
            <div className={styles.invMessage}>
                <h1 className='h3 mb-2'>We were unable to process your request.</h1>
                <p className='pb-0 mb-0'>
                    {`Please contact Customer Support at  ${brandPhoneContent?.[assetDetails?.accountName] || brandPhoneContent?.['aig']}`}
                </p>
            </div>
        </div>
    );
};

export default TermsAndConditionsError;
